<template>
    <div class="program-item">
        <div class="program-item__time">
            <span class="program-item__hour">{{ item.hour }}</span>
        </div>
        <div class="program-item__content">
            <div class="program-item__img">                    
                <Image :image="item.image" :width="350" :height="197"></Image>
            </div>

            <div class="program-item__info">
                <h2 class="program-item__title" v-html="item.title"></h2>

                <div class="program-item__timeline" v-if="item.isTimeline && item.progress && item.progress <= 100">
                    <span class="program-item__progress" :style="{ width: item.progress + '%' }"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Image from "../elements/Image.vue";

export default {
    name: "ModuleProgramItem",
    components: {
        Image
    },
    props: {
        item: {
            type: Object,
            required: true,
        }
    }
}
</script>